import React, { useState } from "react";

/** helpers */
import clsx from "clsx";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";
import { Box, Button, Collapse, Stack } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    boxedWrapper: {
        ...theme.shape.boxedWrapper,
        padding: theme.spacing(3, 3),
        minHeight: theme.spacing(10), //96,
        position: "relative",
        display: "flex",
        alignItems: "center",
        minHeight: 110,
        [theme.breakpoints.down("sm")]: {
            minHeight: "unset",
            padding: theme.spacing(2.5, 3),
        },
    },
    btnFilters: {
        fontSize: "1.11111111rem",
        margin: theme.spacing(1,0),
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.88888889rem",
            padding: theme.spacing(1),
            margin:0
        },
    },
    btnFiltersCollapse: {},
    collapse: {
        margin: 0,
        marginBottom: theme.spacing(1),
    },
    collapsed: {
        marginBottom: theme.spacing(0),
    },
    btnWrapLeft: {
        [theme.breakpoints.down("sm")]: {
            minWidth: "50%",
        },
    },
    btnWrapRight: {
        [theme.breakpoints.down("sm")]: {
            // display: "none",
        },
    },
}));

const Collapsor = (props) => {
    const { leftButtonTitle, rightButton } = props;
    const classes = useStyles();

    /** states */
    const [OPEN, setOPEN] = useState(true);

    /** handlers */
    const handleChange = () => {
        setOPEN((prev) => !prev);
    };

    return (
        <>
            <Stack spacing={0} sx={{ width: "100%" }}>
                <Box sx={{ width: "100%" }}>
                    <Stack direction="row" spacing={0} justifyContent={"space-between"}>
                        <Box sx={{ display: "flex", alignItems: "center" }} className={classes.btnWrapLeft}>
                            <Button
                                color={"primary"}
                                onClick={handleChange}
                                endIcon={!!OPEN ? <ExpandLess /> : <ExpandMore />}
                                className={clsx(classes.btnFilters, OPEN || classes.btnFiltersCollapse)}
                            >
                                {leftButtonTitle}
                            </Button>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }} className={classes.btnWrapRight}>
                            {!!rightButton && rightButton}
                        </Box>
                    </Stack>
                </Box>
                <Collapse in={OPEN} className={clsx(classes.collapse, OPEN || classes.collapsed)}>
                    <Box sx={{ width: "100%" }}>{props.children}</Box>
                </Collapse>
            </Stack>
        </>
    );
};

export default Collapsor;
